import { createShader } from "shaders/js";

export default function initServiceFourHero() {
  (async () => {
    const isDarkMode =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    const service_hero_canvas = document.getElementById(
      "service-four-hero-shader",
    );
    const service_hero_shader = await createShader(service_hero_canvas, {
      components: [
        {
          type: "SolidColor",
          id: "idm8k2p9xa",
          props: {
            color: isDarkMode ? "#060B15" : "#F3F1ED",
            visible: true,
          },
        },
        {
          type: "Group",
          id: "idmm5st55mmjp1tc7pj",
          props: {
            maskSource: "idmq7201cp3ftrtz1mc",
            maskType: "luminance",
            opacity: 0.8,
            visible: true,
          },
          children: [
            {
              type: "ImageTexture",
              id: "idmq6zsh1at1qv9qfvq",
              props: {
                objectFit: "fill",
                url: "https://data.shaders.com/storage/v1/object/public/user-uploaded-images/user_3ClfVtNyX5rVH9kdPNs8UKZRzO0/rL-OVZDi0z33.png",
                visible: true,
              },
            },
            {
              type: "GridDistortion",
              id: "idmlnaml2642babxhpk",
              props: {
                decay: 5,
                gridSize: 100,
                radius: 3,
                visible: true,
              },
            },
          ],
        },
        {
          type: "Group",
          id: "idmq7201cp3ftrtz1mc",
          props: {
            visible: false,
          },
          children: [
            {
              type: "LinearGradient",
              id: "idmq71xe8j9gsh4anv8",
              props: {
                colorA: "#000000",
                colorB: "#ffffff",
                end: {
                  x: 0.5,
                  y: 1,
                },
                start: {
                  x: 0.5,
                  y: 0.5,
                },
                transform: {
                  offsetY: -0.5,
                },
              },
            },
            {
              type: "LinearGradient",
              id: "idmq71yrbo6p6nzrol5",
              props: {
                colorA: "#ffffff",
                colorB: "#000000",
                end: {
                  x: 0.5,
                  y: 0.5,
                },
                start: {
                  x: 0.5,
                  y: 0,
                },
                transform: {
                  offsetY: 0.5,
                },
              },
            },
          ],
        },
      ],
    });

    let service_hero_shader_timeout = null;

    window.addEventListener("resize", function (e) {
      clearTimeout(service_hero_shader_timeout);
      service_hero_shader_timeout = setTimeout(function () {
        service_hero_canvas.style.width =
          service_hero_canvas.parentElement.offsetWidth + "px";
        service_hero_canvas.style.height =
          service_hero_canvas.parentElement.offsetHeight + "px";
        service_hero_shader.resize();
      }, 250);
    });
  })();
}
